<script setup lang="ts">
import { computed } from 'vue';
import { RouterLink, RouterView, useRoute, useRouter } from 'vue-router';
import { useSuperAdminStore } from './stores/superAdmin';

const store = useSuperAdminStore();
const route = useRoute();
const router = useRouter();

const showChrome = computed(() => store.isAuthenticated && route.name !== 'login');

const nav = [
    { name: 'tenants', label: 'Lojas' },
    { name: 'plans', label: 'Planos' },
    { name: 'catalog', label: 'Catálogo de Features' },
    { name: 'base-catalog', label: 'Catálogo Base' },
];

async function onLogout() {
    await store.logout();
    router.push({ name: 'login' });
}
</script>

<template>
    <div class="min-h-screen">
        <header v-if="showChrome" class="border-b" style="border-color: var(--sa-border); background: var(--sa-surface)">
            <div class="mx-auto flex max-w-6xl items-center gap-6 px-6 py-3">
                <span class="text-sm font-bold tracking-tight">Zeca · Super-Admin</span>
                <nav class="flex gap-1">
                    <RouterLink
                        v-for="item in nav"
                        :key="item.name"
                        :to="{ name: item.name }"
                        class="rounded-md px-3 py-1.5 text-sm font-medium transition-colors"
                        :style="route.name === item.name || (item.name === 'tenants' && route.name === 'tenant-detail')
                            ? 'background: var(--sa-primary); color: white'
                            : 'color: var(--sa-muted)'"
                    >
                        {{ item.label }}
                    </RouterLink>
                </nav>
                <div class="ml-auto flex items-center gap-3 text-sm" style="color: var(--sa-muted)">
                    <span>{{ store.user?.email }}</span>
                    <button class="rounded-md px-3 py-1.5 font-medium transition-colors hover:text-white" @click="onLogout">
                        Sair
                    </button>
                </div>
            </div>
        </header>

        <main :class="showChrome ? 'mx-auto max-w-6xl px-6 py-8' : ''">
            <RouterView v-if="store.booted" />
            <div v-else class="flex min-h-screen items-center justify-center text-sm" style="color: var(--sa-muted)">
                Carregando…
            </div>
        </main>
    </div>
</template>
